<template>
  <el-dialog :close-on-click-modal="false" custom-class="webpay user" :visible.sync="visibleInner" top="1vh">
    <span slot="title" v-if="!loading">
      <h4 v-if="!editMode">Информация о пользователе</h4>
      <h4 v-if="editMode && user.id">{{ $t('edit_user') }}</h4>
      <h4 v-if="editMode && !user.id">{{ $t('add_user') }}</h4>
    </span>
    <div class="user_info" v-loading="loading">
      <el-form
        ref="userForm"
        class="form_user_info_edit"
        @submit.native.prevent="save"
        :show-message="false"
        :model="user"
        :disabled="!editMode"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item
              prop="username"
              class="input_border"
              :label="$t('username') + ':'"
            >
              <el-input size="medium" v-model="user.username"></el-input>
            </el-form-item>
            <el-form-item
              prop="firstname"
              class="input_border"
              :label="$t('firstname') + ':'"
            >
              <el-input size="medium" v-model="user.firstname"></el-input>
            </el-form-item>
            <el-form-item
              prop="lastname"
              class="input_border"
              :label="$t('lastname') + ':'"
            >
              <el-input size="medium" v-model="user.lastname"></el-input>
            </el-form-item>
            <el-form-item
              prop="phone"
              class="input_border"
              :label="$t('phone') + ':'"
            >
              <el-input
                size="medium"
                minlength="10"
                v-model="user.phone"
              ></el-input>
            </el-form-item>
            <el-form-item prop="email" class="input_border" label="E-mail:">
              <el-input size="medium" v-model="user.email"></el-input>
            </el-form-item>
            <el-form-item
              prop="company"
              class="input_border"
              :label="$t('company') + ':'"
            >
              <el-input size="medium" v-model="user.company"></el-input>
            </el-form-item>
            <el-form-item
              prop="fax"
              class="input_border"
              :label="$t('fax') + ':'"
            >
              <el-input
                size="medium"
                minlength="10"
                v-model="user.fax"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="country_id"
              class="input_border"
              :label="$t('country') + ':'"
            >
              <el-select
                size="medium"
                v-model="user.country_id"
                placeholder=" "
              >
                <el-option
                  v-for="country in countries"
                  :key="country.value"
                  :label="country.label"
                  :value="country.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item
              prop="state"
              class="input_border"
              :label="$t('state') + ':'"
            >
              <el-input size="medium" v-model="user.state"></el-input>
            </el-form-item>
            <el-form-item
              prop="zip"
              class="input_border"
              :label="$t('zip') + ':'"
            >
              <el-input
                size="medium"
                minlength="4"
                v-model="user.zip"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="city"
              class="input_border"
              :label="$t('city') + ':'"
            >
              <el-input size="medium" v-model="user.city"></el-input>
            </el-form-item>
            <el-form-item
              prop="address1"
              class="input_border"
              :label="$t('address') + ':'"
            >
              <el-input size="medium" v-model="user.address1"></el-input>
            </el-form-item>
            <el-form-item
              v-if="billings.length"
              prop="bid"
              class="input_border"
              :label="$t('billing_name') + ':'"
            >
              <el-select size="medium" v-model="user.bid" placeholder=" " filterable clearable>
                <el-option
                  v-for="billing in billings"
                  :key="billing.value"
                  :label="billing.label"
                  :value="billing.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="input_border"
              prop="multi_login"
              :label="$t('multi_login') + ':'"
            >
              <el-select
                size="medium"
                v-model="user.multi_login"
                placeholder=" "
              >
                <el-option :label="$t('yes')" value="1"></el-option>
                <el-option :label="$t('no')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="status"
              class="input_border"
              :label="$t('active') + ':'"
            >
              <el-select size="medium" v-model="user.status" placeholder=" ">
                <el-option :label="$t('yes')" value="1"></el-option>
                <el-option :label="$t('no')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="wide_access"
              class="input_border"
              :label="$t('wide_access') + ':'"
            >
              <el-select
                size="medium"
                v-model="user.wide_access"
                placeholder=" "
              >
                <el-option :label="$t('yes')" value="1"></el-option>
                <el-option :label="$t('no')" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <h5>{{ $t('groups') }}:</h5>
          <el-row>
            <el-form-item class="input_border" prop="g">
              <el-select
                size="medium"
                @change="changeGroups"
                multiple
                v-model="allGroups"
                placeholder=" "
              >
                <el-option
                  v-for="group in groups"
                  :disabled="disabledGroups.indexOf(group.value) > -1"
                  :key="group.value"
                  :label="group.label"
                  :value="group.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>
        <div>
          <h5>{{ $t('notes') }}</h5>
          <el-form-item prop="notes" class="input_border">
            <el-input
              size="medium"
              type="textarea"
              cols="30"
              rows="10"
              v-model="user.notes"
            ></el-input>
          </el-form-item>
        </div>
        <el-row :gutter="20" v-if="editMode">
          <el-col :sm="8">
            <el-form-item prop="password" class="input_border">
              <el-input
                size="medium"
                minlength="5"
                type="password"
                :placeholder="$t('password')"
                v-model="user.password"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item prop="cpassword" class="input_border">
              <el-input
                size="medium"
                type="password"
                :placeholder="$t('password_confirm')"
                v-model="user.cpassword"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="aligner right">
          <el-button
            v-if="!editMode"
            round
            type="primary"
            @click.prevent="edit()"
            >{{ $t('edit') }}</el-button
          >
          <el-button
            v-if="editMode"
            round
            type="primary"
            native-type="submit"
            >{{ $t('save') }}</el-button
          >
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'user-modal',
  props: ['visible', 'url', 'callback'],
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  data () {
    let confirmValidate = (r, v, c) => {
      c(v !== this.user.password ? new Error() : undefined)
    }
    let user = {
      id: '',
      username: '',
      password: '',
      cpassword: '',
      firstname: '',
      lastname: '',
      email: '',
      company: '',
      address1: '',
      city: '',
      state: '',
      zip: '',
      country_id: '',
      phone: '',
      fax: '',
      bid: '',
      notes: '',
      multi_login: '1',
      wide_access: '1',
      status: '1',
      g: [],
      submit: 'Подтвердить'
    }
    return {
      editMode: true,
      loading: true,
      vars: {},
      user: user,
      rules: {
        username: { required: true, trigger: 'blur' },
        password: { required: true, trigger: 'blur' },
        cpassword: { validator: confirmValidate },
        firstname: { required: true, trigger: 'blur' },
        lastname: { required: true, trigger: 'blur' },
        email: { required: true, trigger: 'blur' },
        address1: { required: true, trigger: 'blur' },
        city: { required: true, trigger: 'blur' },
        zip: { required: true, trigger: 'blur' },
        country_id: { required: true, trigger: 'blur' },
        phone: { required: true, trigger: 'blur' },
        bid: { required: true, trigger: 'blur' },
        g: { required: true, trigger: 'blur' }
      },
      countries: [],
      billings: [],
      groups: [],
      disabledGroups: [],
      allGroups: [],
      groupsRelations: {},
      keys: Object.keys(user)
    }
  },
  created () {
    apiRes.get(this.url).then(res => {
      if (res.page_vars) {
        this.vars = res.page_vars
        if (this.vars.account_res) {
          Object.assign(this.user, this.vars.account_res)
          this.rules.password.required = !this.user.id
          this.user.multi_login =
            this.user.multi_login === null ||
              this.user.multi_login === undefined
              ? '1'
              : this.user.multi_login.toString()
          this.user.wide_access =
            this.user.wide_access === null ||
              this.user.wide_access === undefined
              ? '1'
              : this.user.wide_access.toString()
          this.user.multi_login =
            this.user.status === null || this.user.status === undefined
              ? '1'
              : this.user.status.toString()
          this.user.g = Object.keys(this.vars.groups_array)
          this.vars.groups_array = this.vars.self_groups_array
        }
        // this.editMode = !this.vars.user

        if (this.vars.country_array) {
          this.countries = Object.keys(this.vars.country_array)
            .filter(k => k !== 'selected_id')
            .map(key => {
              return {
                label: key,
                value: this.vars.country_array[key]
              }
            })

          this.user.country_id = this.vars.country_array.selected_id
            ? this.vars.country_array.selected_id
            : this.countries[0].value
        }

        if (this.vars.billing_array && this.vars.billing_array.bid) {
          this.billings = Object.keys(this.vars.billing_array.bid)
            .filter(k => k !== 'selected_id')
            .map(key => {
              return {
                label: key,
                value: this.vars.billing_array.bid[key]
              }
            })

          this.user.bid = this.vars.billing_array.bid.selected_id
            ? this.vars.billing_array.bid.selected_id
            : this.billings[0].value
        }

        if (this.vars.groups_array) {
          let childs = {}
          this.groups = Object.keys(this.vars.groups_array)
            .map(key => {
              let parentId = this.vars.groups_array[key].parent_id
              if (!childs[parentId]) {
                childs[parentId] = [key]
              } else {
                childs[parentId].push(key)
              }
              return {
                value: key,
                label: this.vars.groups_array[key].name
              }
            })
            .sort((g1, g2) => (g1.value < g2.value ? 1 : -1))

          this.groupsRelations = {}

          let getChilds = value => {
            let children = childs[value]
            return children
              ? [children]
                .concat(children.map(v => getChilds(v)))
                .reduce((a, b) => a.concat(b), [])
              : []
          }

          this.groupsRelations = {}
          this.groups.forEach(g => {
            this.groupsRelations[g.value] = getChilds(g.value)
          })
          this.allGroups = this.user.g
          this.changeGroups()
        }
      }
      this.loading = false
    })
  },
  methods: {
    changeGroups () {
      this.user.g = this.allGroups
      this.disabledGroups = this.user.g
        .map(id => this.groupsRelations[id])
        .reduce((a, b) => a.concat(b), [])
        .filter((v, i, s) => s.indexOf(v) === i)
      this.allGroups = this.user.g
        .concat(this.disabledGroups)
        .filter((v, i, s) => s.indexOf(v) === i)
        .sort((g1, g2) => (g1 < g2 ? 1 : -1))
    },
    edit () {
      this.editMode = true
    },
    save () {
      this.$refs['userForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let toSend = {}
          Object.assign(toSend, this.user)
          if (!this.billings.length) delete toSend['bid']
          apiRes
            .post(this.url, toSend)
            .then(res => {
              if (res.page_vars) {
                this.callback(res.page_vars)
                this.visibleInner = false
              }

              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style>
.el-dialog.webpay.user {
  max-width: 750px;
  padding: 10px 30px;
}

.el-dialog.webpay.user .el-form-item {
  margin: 0;
}

.form_user_info_edit .el-input .el-input__inner,
.form_user_info_edit .el-textarea .el-textarea__inner {
  transition: 0.2s;
}

.form_user_info_edit .el-input.is-disabled .el-input__inner,
.form_user_info_edit .el-textarea.is-disabled .el-textarea__inner {
  background: transparent;
  border: none;
}

.form_user_info_edit .el-input.is-disabled .el-input__suffix {
  display: none;
}

.form_user_info_edit input[type='text'],
.form_user_info textarea,
.form_user_info_edit label {
  background-color: transparent;
}
</style>
